import $ from 'jquery';
import {Fee} from './FeeSchedule';

class AdjusterShareSelector {

  constructor(fee) {
    if (fee === undefined) {
      fee = new Fee();
      delete fee.uuid;
    }
    this.fee = fee;
  }

  reset() {
    let fee = new Fee();
    delete fee.uuid;
    this.fee = fee;
    this.setData();
    this.$input.val('');
  }

  types() {

    if (!this.typesLookup) {
      this.typesLookup = {
        'default': {value: 'default', text: 'Default'},
        'none': {value: 'none', text: 'None - 0%'},
        'all': {value: 'all', text: 'All - 100%'},
        'custom': {value: 'custom', text: 'Custom'},
      };
    }

    return this.typesLookup;
  }

  typeText(type) {
    let types = this.types();
    return types[type].text;
  }

  build() {

    this.$root = $('<div/>')
      .addClass('adjuster-share-selector');

    this.$inputGroup = $('<div/>')
      .addClass('input-group input-group-sm')
      .appendTo(this.$root);

    this.$hiddenType = $('<input/>')
      .attr('type', 'hidden')
      .attr('data-field', 'adjuster_payout.type')
      .appendTo(this.$root);


    this.$addonDiv = $('<div/>')
      .addClass('input-group-prepend')
      .appendTo(this.$inputGroup);

    this.$addon = $('<span/>')
      .addClass('input-group-addon')
      .text('$')
      .appendTo(this.$addonDiv);

    this.$input = $('<input/>')
      .attr('type', 'text')
      .attr('data-field', 'adjuster_payout.rate')
      .addClass('form-control')
      .val(this.fee.adjuster_payout.rate)
      .appendTo(this.$inputGroup);

    if (this.fee.uuid) {
      this.$hiddenType.attr('name', 'other_fee_adjuster_payout_type[]');
      this.$input.attr('name', 'other_fee_adjuster_payout_rate[]');
    }
    else {
      this.$hiddenType.attr('id', 'new_fee_adjuster_payout_type');
      this.$input.attr('id', 'new_fee_adjuster_payout_rate');
    }

    this.$dropup = $('<div/>').addClass('input-group-append dropup').appendTo(this.$inputGroup);
    this.$dropupToggle = $('<button/>')
      .attr('type', 'button')
      .attr('data-toggle', 'dropdown')
      .addClass('btn btn-primary dropdown-toggle')
      .appendTo(this.$dropup);

    this.$menu = $('<ul/>')
      .addClass('dropdown-menu')
      .appendTo(this.$dropup);

    let types = this.types();

    for (let type of Object.keys(types)) {
      type = types[type];
      let $li = $('<li/>').appendTo(this.$menu);

      let $a = $('<a/>')
        .attr('href', '#')
        .attr('data-type', type.value)
        .text(type.text)
        .appendTo($li);
    }

    this.setData();
    this.setupEvents();
  }

  setData() {
    let isCustom = this.fee.adjuster_payout.type === 'custom';
    this.setCustomUI(isCustom);

    this.$hiddenType.val(this.fee.adjuster_payout.type);

    this.$dropupToggle.text(this.typeText(this.fee.adjuster_payout.type) + ' ');
    $('<span/>').addClass('caret').appendTo(this.$dropupToggle);

    this.$menu.find('a[data-type] > i.fa').remove();
    let $selected = this.$menu.find('a[data-type=' + this.fee.adjuster_payout.type + ']');

    $('<i/>')
      .addClass('fa fa-lg fa-check text-success float-right mr-n2')
      .appendTo($selected);
  }

  setCustomUI(isCustom) {
    let $custom = this.$addon.add(this.$input);

    if (isCustom) {
      $custom.removeClass('d-none');
      this.$dropup.removeClass('flex-fill');
      this.$dropupToggle.removeClass('btn-block');
    }
    else {
      $custom.addClass('d-none');
      this.$dropup.addClass('flex-fill');
      this.$dropupToggle.addClass('btn-block');
    }
  }

  setupEvents() {

    let _this = this;

    this.$root.on('click', 'ul.dropdown-menu > li > a[data-type]', function(e) {
      e.preventDefault();
      let type = $(e.currentTarget).data('type');
      _this.fee.adjuster_payout.type = type;
      _this.setData();
    });
  }

  attach($parent) {

    if (!this.$root) {
      this.build();
    }

    $parent.append(this.$root);
  }
}

export default AdjusterShareSelector;
